import { action, computed, makeObservable, observable } from 'mobx'
import { DTO } from 'src/dto'

import type { BookType } from '@/types/learningContent'

export class PrintRangeOption extends DTO {
  problem = true // 문제
  quickAnswer = false // 빠른 정답
  answer = false // 답안
  omr = false // 채점지
  inputText = ''
  type: BookType | 'ARITHMETIC' = 'WORKSHEET'

  constructor(type: BookType = 'WORKSHEET') {
    super()
    makeObservable(this, {
      problem: observable,
      quickAnswer: observable,
      answer: observable,
      omr: observable,
      inputText: observable,
      allSelect: computed,
      allNotSelect: computed,
      reset: action,
    })

    this.type = type
  }

  get allSelect() {
    switch (this.type) {
      case 'WORKSHEET':
        return this.problem && this.answer && this.omr && this.quickAnswer
      case 'WORKBOOK':
        return this.problem && this.answer
      case 'ARITHMETIC':
        return this.problem && this.quickAnswer
    }
  }

  get allNotSelect() {
    switch (this.type) {
      case 'WORKSHEET':
        return !this.problem && !this.answer && !this.omr && !this.quickAnswer
      case 'WORKBOOK':
        return !this.problem && !this.answer
      case 'ARITHMETIC':
        return !this.problem && !this.quickAnswer
    }
  }

  get isRangedInputText() {
    return !!this.inputText.length
  }

  isOverMaxPage(maxPage: number) {
    return (
      Math.max(...this.inputText.split('-').flatMap((textArr) => Number(textArr.split(',')))) >
      maxPage
    )
  }

  reset() {
    this.problem = true // 문제
    this.quickAnswer = false // 빠른 정답
    this.answer = false // 답안
    this.omr = false // 채점지
    this.inputText = ''
    this.type = 'WORKSHEET'
  }
}
